import { useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, ShieldCheck, ArrowRight, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/nav";
import { isStaff, ROLE_LABEL } from "@/lib/roles";

export default function ChooseDestination() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    if (user && !isStaff(user)) return <Navigate to="/dashboard" replace />;

    const cards = [
        { title: "Player App", desc: "Your dashboard, clips, coaching and analytics.", icon: LayoutDashboard, to: "/dashboard", testid: "choose-app", color: "#00C2FF" },
        { title: "Owner Portal", desc: `Signed in as ${ROLE_LABEL[user?.role] || "Staff"} — manage the platform.`, icon: ShieldCheck, to: "/admin", testid: "choose-admin", color: "#00E676" },
    ];

    return (
        <div className="min-h-screen bg-obsidian ww-grid-bg flex flex-col items-center justify-center p-6">
            <div className="flex items-center gap-3 mb-10">
                <div className="w-11 h-11 rounded-sm bg-black border border-white/10"
                    style={{ backgroundImage: `url(${LOGO_URL})`, backgroundSize: "175%", backgroundPosition: "center 32%", backgroundRepeat: "no-repeat" }} />
                <div>
                    <div className="font-heading font-extrabold text-xl tracking-tight">WhiteWater<span className="text-volt">AI</span></div>
                    <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Welcome back, {user?.first_name || user?.name}</div>
                </div>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl font-black tracking-tighter text-white mb-2">Where to?</h1>
            <p className="text-sm text-muted-foreground mb-8">You're signed in as an owner. Choose your destination.</p>

            <div className="grid sm:grid-cols-2 gap-5 w-full max-w-2xl ww-fade-up">
                {cards.map((c) => (
                    <button key={c.to} onClick={() => navigate(c.to)} data-testid={c.testid}
                        className="group text-left bg-surface border border-border rounded-sm p-6 hover:border-white/30 transition-all hover:-translate-y-0.5">
                        <span className="grid place-items-center w-12 h-12 rounded-sm mb-4" style={{ background: `${c.color}1a` }}>
                            <c.icon className="w-6 h-6" style={{ color: c.color }} />
                        </span>
                        <div className="font-heading font-bold text-lg text-white flex items-center gap-2">
                            {c.title}
                            <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-volt group-hover:translate-x-1 transition-all" />
                        </div>
                        <p className="text-sm text-muted-foreground mt-1">{c.desc}</p>
                    </button>
                ))}
            </div>

            <button onClick={logout} data-testid="choose-logout" className="mt-10 text-sm text-muted-foreground hover:text-alert flex items-center gap-2">
                <LogOut className="w-4 h-4" /> Sign out
            </button>
        </div>
    );
}
